import React, { useRef } from "react";
import Frame from "./Frame";
import {Box, useTheme, Typography} from "@mui/material";
import { TwitterPicker, CirclePicker , GithubPicker} from "react-color";
import { useDispatch, useSelector } from "react-redux";
import { setColor} from "../../slices/sign_image_editor"
import { tokens } from "../../theme";

const ColourPicker = (props) =>  {

  const selectedColor = useSelector((state) => state.imageEditor.selectedColor);

  const theme = useTheme()
  const colors = tokens(theme.palette.mode);

  const dispatch = useDispatch();

  const updateColor = (color) => {

    dispatch(setColor(color.hex))
  }

  const colours = [

    "#f4f5ef",
"#f8c7a4",
"#e784a8",
"#eb9d45",
"#bb9a3e",
"#f6e455",
"#c8dbdf",
"#a146aa",
"#d74d4c",
"#a65d35",
"#8fcb62",
"#35884e",
"#a0abb1",
"#962f2c",
"#682d2c",
"#85dfeb",
"#339ca3",
"#1b4c5a",
"#5e6a82",
"#191023",
"#72adee",
"#435edb",
"#474394",
"#322d4d",
"#000000",
"#646464",
"#ffffff",
"#ff0000",
"#00ff00",
"#0000ff",

  ]

  return (

    <Box
    display = "flex"
    flexDirection="column"
    width = "100%"
    backgroundColor={colors.primary[300]} 
    sx={{ borderRadius:2}}
    p=".5rem 1rem 1rem 1rem"
>

  <Box dispay="flex" alignContent="center" mb=".5rem">
    <Typography variant="h3" align="center">Colours</Typography>
  </Box>

    <CirclePicker color={selectedColor} colors = {colours}  onChangeComplete={updateColor} triangle="hide"/>

    </Box>
  );
}

export default ColourPicker;